import React from "react";
import {cx} from "../../lib/ClassSet";
import NoteTags from "../NoteTags";
import {Link} from "react-router";
import { linkForType } from "../notes";
import "./NoteItem.scss";

const NoteItem = (props) => {

  let {data} = props;

  let classes = cx({
    "item": true,
    "note-list-item": true,
    "u-selected": props.selected,
    "u-active": data.get("active") === true,
    "u-deactivated": data.get("active") !== true,
  })

  let linkInfo = linkForType(data.get("foreignType"), data.get("foreignId"));

  return (
    <tr className={classes} onClick={(e) => props.onClick(data, e)}>
      <td className="field f-title">{data.get("title")}</td>
      <td className="field f-type u-nowrap"><Link to={linkInfo.get("path")}>{linkInfo.get("title")}</Link></td>
      <td className="field f-tags u-nowrap"><NoteTags ids={data.get("tags")} /></td>
    </tr>
  )
}

export default NoteItem;